import { machineFailureReasonApi } from "@/core/apis";

// getter types
export const MACHINE_FAILURE_REASONS = "machineFailureReasons";

// action types
export const GET_MACHINE_FAILURE_REASONS = "getMachineFailureReasons";

// mutation types
const SET_MACHINE_FAILURE_REASONS = "setMachineFailureReasons";

const state = {
  machineFailureReasons: []
};

const getters = {
  [MACHINE_FAILURE_REASONS](state) {
    return state.machineFailureReasons;
  }
};

const actions = {
  [GET_MACHINE_FAILURE_REASONS](context) {
    return new Promise(resolve => {
      machineFailureReasonApi.getAllMachineFailures().then(response => {
        context.commit(SET_MACHINE_FAILURE_REASONS, response);

        resolve();
      });
    });
  }
};

const mutations = {
  [SET_MACHINE_FAILURE_REASONS](state, machineFailureReasons) {
    state.machineFailureReasons = machineFailureReasons;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
